// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { handleNotificationError, useLocalMessage } from '@Helpers/';
import client, { queryClient } from '@Client';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THPopConfirm } from '@Molecules/Inputs/THPopConfirm/THPopConfirm';

import './NoMFA.scss';

const unsetMFA = async (onSuccess: () => void): Promise<void> => {
    try {
        await client.AuthController.unsetMFA();
        onSuccess();
    } catch (e) {
        handleNotificationError(e);
    }
};

const NoMFA = (): ReactElement => {
    const i = useLocalMessage();

    const handleClick = (): void => {
        unsetMFA(() => {
            queryClient.refetchQueries('currentUser');
        });
    };

    return (
        <div className="no-mfa">
            <span className="text">{i('account.mfa.disable.warning')}</span>
            <THPopConfirm title={i('account.mfa.disable.confirm')} onConfirm={handleClick}>
                <THButton type="primary" danger>
                    {i('account.mfa.disable.label')}
                </THButton>
            </THPopConfirm>
        </div>
    );
};

export default NoMFA;
